import { ClerkProvider as BaseClerkProvider } from "@clerk/tanstack-react-start";
import type { ReactNode } from "react";
import { env } from "@/env/client";

type ClerkProviderProps = {
  children: ReactNode;
};

export function ClerkProvider({ children }: ClerkProviderProps) {
  return (
    <BaseClerkProvider
      appearance={{
        elements: {
          rootBox: "mx-auto",
          card: "shadow-xl rounded-xl border border-gray-200",
          formButtonPrimary:
            "bg-primary hover:bg-primary/90 text-primary-foreground",
          formFieldInput: "bg-background",
          footer: "text-muted-foreground text-sm",
          headerTitle: "text-foreground",
          headerSubtitle: "text-muted-foreground",
        },
      }}
      publishableKey={env.VITE_CLERK_PUBLISHABLE_KEY}
    >
      {children}
    </BaseClerkProvider>
  );
}
